import { compose, createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { rootReducer } from "./reducers/rootReducer";

const middleWares = [logger, thunk];

const composedEnhancers = compose(applyMiddleware(...middleWares));

// rootReducers, inititaldata, middlwares
const Store = createStore(rootReducer, {}, composedEnhancers);

export default Store;
